// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DesignCategories_wrapper__bc9hG","item":"DesignCategories_item__GkRn3"};